module.exports = __webpack_public_path__ + "img/ad-bn.85740a9a.png";